import { CompetencyTranslationFieldKind } from '@/constants/competencies/CompetencyTranslationFieldKind';

export const COMPETENCY_TRANSLATION_FIELD_MAX_LENGTH: Record<
    CompetencyTranslationFieldKind,
    number | undefined
> = {
    [CompetencyTranslationFieldKind.GROUP_NAME]: 100,
    [CompetencyTranslationFieldKind.GROUP_DESCRIPTION]: 500,
    [CompetencyTranslationFieldKind.COMPETENCY_NAME]: 100,
    [CompetencyTranslationFieldKind.COMPETENCY_DESCRIPTION]: 500,
    [CompetencyTranslationFieldKind.QUESTION_LABEL]: undefined,
    [CompetencyTranslationFieldKind.OPTION_LABEL]: undefined,
};
